import { component as defineComponent } from 'flightjs';

let ddoLink = function() {
    this.after('initialize', function() {
        this.on('click', this.handleClick);
    });

    this.handleClick = function(e, data) {
        if (e.metaKey || e.ctrlKey) {
            return true;
        }

        e.preventDefault();

        // FIXME: Dodgy data reading from some parent somewhere up the tree
        const { designCollection } = $(e.target)
            .parents('[data-design-collection]')
            .data();

        window.dispatchEvent(
            new window.CustomEvent('launchDesignView', {
                detail: {
                    designCollection,
                    path: this.node.getAttribute('href'),
                },
            })
        );
    };
};

export default defineComponent(ddoLink);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/ddo-link.js